import routes from '@modules/subproperty-people/subproperty-people-routes';
import store from '@modules/subproperty-people/subproperty-people-store';

export default {
  routes,
  store
};
